import React from 'react';
import './Bottombar.css';

const Bottombar = () => (
  <footer className="bottombar">
    <div className="bottombar-inner">
      <span className="bottombar-brand">Softick LLC</span>
      <ul className="bottombar-links">
        <li><a href="/services">Services</a></li>
        <li><a href="/domain">Domain</a></li>
        <li><a href="/clients">Clients</a></li>
        <li><a href="/capability">Capability Statement</a></li>
        <li><a href="/contact">Contact Us</a></li>
      </ul>
      <span className="bottombar-copy">© {new Date().getFullYear()} Softick LLC — All Rights Reserved</span>
    </div>
  </footer>
);

export default Bottombar;